import { useNavigate, useSearchParams } from "react-router-dom";
import { useInvestorSession } from "./useInvestorSession";
import {
  getInvestorQueryParams,
  withInvestorQuery,
  withProfileVerificationQuery,
} from "../utils/investorRouteHelpers";

export function useInvestorGate() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const query = getInvestorQueryParams(searchParams);
  const { isKycApproved, kycStatus, isLoggedIn } = useInvestorSession();

  const redirectToKyc = (extraQuery = {}) => {
    const merged = { ...query, ...extraQuery };
    navigate(withProfileVerificationQuery(merged));
  };

  const redirectToLogin = (redirectPath, extraQuery = {}) => {
    const merged = {
      ...query,
      ...extraQuery,
      redirect: redirectPath || extraQuery.redirect || query.redirect,
    };
    navigate(withInvestorQuery("/login", merged));
  };

  const ensureKycApproved = (options = {}) => {
    if (isKycApproved) return true;
    redirectToKyc(options);
    return false;
  };

  const ensureLoggedIn = (redirectPath, extraQuery = {}) => {
    if (isLoggedIn) return true;
    redirectToLogin(redirectPath || query.redirect, extraQuery);
    return false;
  };

  const ensureOrderAccess = (redirectPath, extraQuery = {}) => {
    if (!ensureLoggedIn(redirectPath, extraQuery)) return false;
    return ensureKycApproved({ redirect: redirectPath, ...extraQuery });
  };

  return {
    isKycApproved,
    isLoggedIn,
    kycStatus,
    query,
    redirectToKyc,
    redirectToLogin,
    ensureKycApproved,
    ensureLoggedIn,
    ensureOrderAccess,
  };
}
